import { useState } from "react";
import styles from "./CollapsibleClinicalSection.module.css";

export default function CollapsibleClinicalSection({
  title,
  children,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={styles.section}>
      <button
        type="button"
        className={styles.header}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <span className={styles.title}>{title}</span>
        <span className={styles.icon}>{open ? "−" : "+"}</span>
      </button>

      {open && <div className={styles.content}>{children}</div>}
    </section>
  );
}
